import { env } from "~/env.mjs";

// Add base url to the href value
// i.e. `/stablecoins` becomes `https://app.rwa.xyz/stablecoins'
export function addBaseUrl(href: string): string {
    return `${env.NEXT_PUBLIC_BASE_URL}${href}`;
}
